'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CouponDisplay = _react2['default'].createClass({
    displayName: 'CouponDisplay',
    render: function render() {
        var couponDesc = '';
        if (this.props.couponDescription) {
            couponDesc = _react2['default'].createElement(
                'div',
                null,
                this.props.couponDescription
            );
        }
        return _react2['default'].createElement(
            'div',
            { 'data-test-id': 'coupon-display',
                className: 'columns small-6 small-centered large-3 m-coupon-display'
            },
            _react2['default'].createElement(
                'div',
                null,
                'Coupon Code:',
                _react2['default'].createElement(
                    'span',
                    { className: 'coupon-code' },
                    this.props.couponCode
                )
            ),
            couponDesc
        );
    }
});

module.exports = CouponDisplay;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/coupon-display.jsx
 ** module id = 1085
 ** module chunks = 0
 **/